const map = {
	"./ar/casino.jpg": 14039,
	"./de/casino.jpg": 50095,
	"./en/casino.jpg": 54471,
	"./fr/casino.jpg": 51484,
	"./it/casino.jpg": 22829,
	"./kh/casino.jpg": 92843,
	"./krt/casino.jpg": 59169,
	"./nl/casino.jpg": 94394,
	"./tr/casino.jpg": 68822
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88405;